import { Candidate, Coalition, Result, Year } from '@/lib/model';
import * as React from 'react';
import './index.scss';

export interface PopupProps {
  x: number;
  y: number;
  offset: number;
  data: Result;
  selectedCandidate: Candidate | null;
  selectedYear: Year;
}

export const Popup: React.FC<PopupProps> = ({
  data,
  x,
  y,
  offset,
  selectedCandidate,
  selectedYear,
}) => (
  <div
    className="Popup"
    style={{
      top: y > 350 ? y - (250 + data.coalitions.length * 16) : y + offset,
      left: x > 265 ? x - 325 : x + offset,
      position: 'sticky',
    }}
  >
    <div className="Popup__title">
      <span>{data.placeName.toLowerCase()}</span>
    </div>
    <div className="Popup__bar">
      {data.coalitions.map((coalition, i) => (
        <div
          style={{
            backgroundColor: coalition.fillColor,
            width: `${coalition.percentage}%`,
          }}
          key={i.toString()}
        />
      ))}
    </div>
    <div className="Popup__information" style={{ fontSize: '0.7rem' }}>
      {selectedYear === Year.Y2023 && (
        <div>
          <span>
            <b>{data.scrutinized.current}</b> di <b>{data.scrutinized.total}</b>{' '}
            sezioni scrutinate
          </span>
        </div>
      )}
      <div>
        <span>
          {`${data.summary.turnout.label}`}:{' '}
          <b>{`${data.summary.turnout.value}`}</b>
        </span>
        <span>
          Voti: <b>{`${data.summary.totalVoters.value}`}</b>
        </span>
      </div>
    </div>
    <div className="Popup__votes">
      <div className="Popup__votes__header">
        {data.showVoti && <span>Voti</span>}
        <span>%</span>
      </div>
      {data.coalitions.map((coalition, i) => {
        if (selectedCandidate) {
          if (coalition.coalitionId !== selectedCandidate.coalitionId) {
            return null;
          }

          if (selectedCandidate.candidateId) {
            coalition = coalition.candidates.find(
              c => c.candidateId === selectedCandidate.candidateId
            ) as Coalition;
          }

          coalition.label = selectedCandidate.label;
        }

        return (
          <div className="Popup__votes__result" key={i.toString()}>
            <div
              className="Popup__votes__result__bar"
              style={{ backgroundColor: coalition.fillColor }}
            />
            <div className="Popup__votes__result__name">
              {selectedYear === Year.Y2023
                ? coalition.fullName
                    ?.replace(
                      'LETIZIA MARIA BRICHETTO ARNABOLDI',
                      'LETIZIA MORATTI'
                    )
                    .toLowerCase()
                    .replace("alessio d'amato", "alessio d'Amato") ||
                  coalition.label
                : coalition.label}
            </div>
            <div className="Popup__votes__result__numbers">
              <span>{coalition.votes}</span>
              <span>
                <strong>{`${coalition.percentage.toFixed(1)}%`}</strong>
              </span>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
